import Loadable from 'react-loadable';
import Loading from 'skd-ui/Loading/Loading';

export default Loadable({
	loader: () => import(/* webpackChunkName: 'CreateMassOperations'*/ 'src/controllers/Accounting/createOperations/CreateMassOperationsController'),
	loading: Loading,
});
